import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import {
  FooterBox,
  FooterContainer,
  FooterRow,
  FooterColumn,
  FooterLink,
  FooterHeading,
  FooterSubHeading,
  FooterText,
  SocialMediaBoxContainer,
} from "./styles";
import { Colors } from "../../../utilities/styles";
import { useEffect, useState } from "react";
import { SiteSettings } from "../../../sanity/types";
import { getSiteSettings } from "../../../sanity/queries";
import { fallbackSiteSettings } from "../../../sanity/fallbacks";
import {AlertToast} from "../../common/alert-toast";

const Footer = () => {
  const [settings, setSettings] =
    useState<SiteSettings>(fallbackSiteSettings);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;
    getSiteSettings()
      .then((data: SiteSettings | null) => {
        if (!isMounted || !data) {
          return;
        }
        setSettings({
          ...fallbackSiteSettings,
          ...data,
        });
      })
      .catch(() => {
        if (isMounted) {
          setSettings(fallbackSiteSettings);
          setErrorMessage("Unable to load site settings. Showing fallback content.");
        }
      })
      .finally(() => {
        /* no loading state tracking needed */
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const address = settings.address || fallbackSiteSettings.address;
  const addressLink =
    settings.addressLink || fallbackSiteSettings.addressLink;
  const phone = settings.phone || fallbackSiteSettings.phone;
  const email = settings.email || fallbackSiteSettings.email;
  const missionStatement =
    settings.missionStatement || fallbackSiteSettings.missionStatement;
  const socialLinks = settings.socialLinks || fallbackSiteSettings.socialLinks;

  return (
    <FooterBox id="FooterContainer">
      <AlertToast
        open={!!errorMessage}
        message={errorMessage}
        onClose={() => setErrorMessage("")}
        severity="warning"
      />
      <FooterContainer>
        <FooterRow>
          <FooterColumn>
            <FooterHeading aria-label="Footer Contact">CONTACT</FooterHeading>
            <div>
              <FooterSubHeading aria-label="St. George Church">
                St. George Church
              </FooterSubHeading>
              <FooterText aria-label="St. George Church Address">
                <b style={{ fontWeight: "bolder" }}>Address - </b>
                <FooterLink href={addressLink}>
                  {address}
                </FooterLink>
              </FooterText>
              <FooterText aria-label="Contact Phone Number">
                <b style={{ fontWeight: "bolder" }}>Phone - </b>
                <FooterLink href={`tel:${phone}`}>{phone}</FooterLink>
              </FooterText>
              <FooterText aria-label="Contact Email">
                <b style={{ fontWeight: "bolder" }}>Email - </b>
                <FooterLink href={`mailto:${email}`}>
                  {email}
                </FooterLink>
              </FooterText>
            </div>
          </FooterColumn>
          <FooterColumn>
            <FooterHeading aria-label="Footer Our Mission">
              OUR MISSION
            </FooterHeading>
            <FooterText aria-label="Our Mission" style={{textAlign: "center"}}>
              {missionStatement}
            </FooterText>
          </FooterColumn>
          <FooterColumn>
            <FooterHeading aria-label="Social Media">SOCIAL MEDIA</FooterHeading>
            <SocialMediaBoxContainer>
              {socialLinks?.x && (
                <FooterLink
                  aria-label="X Link"
                  sx={{ "&:hover": { color: Colors.XBlack } }}
                  href={socialLinks.x}
                  rel="noopener"
                  target="_blank"
                >
                  < XIcon/>
                </FooterLink>
              )}
              {socialLinks?.facebook && (
                <FooterLink
                  aria-label="Facebook Link"
                  sx={{ "&:hover": { color: Colors.BlueFacebook } }}
                  target="_blank"
                  href={socialLinks.facebook}
                  rel="noopener"
                >
                  <FacebookIcon />
                </FooterLink>
              )}
              {socialLinks?.youtube && (
                <FooterLink
                  aria-label="Youtube Link"
                  sx={{ "&:hover": { color: Colors.RedYoutube } }}
                  href={socialLinks.youtube}
                  rel="noopener"
                  target="_blank"
                >
                  <YouTubeIcon />
                </FooterLink>
              )}
              {socialLinks?.soundcloud && (
                <FooterLink
                  aria-label="Soundcloud Link"
                  sx={{ "&:hover": { color: Colors.OrangeSoundcloud } }}
                  href={socialLinks.soundcloud}
                  rel="noopener"
                  target="_blank"
                >
                  <LibraryMusicIcon />
                </FooterLink>
              )}
            </SocialMediaBoxContainer>
          </FooterColumn>
        </FooterRow>
      </FooterContainer>
    </FooterBox>
  );
};
export default Footer;
